export enum MissingAllType {
    NONE = 0,
    V_6 = 1,
    V_7 = 2
}